module.exports = __webpack_public_path__ + "img/ic_wechat_nor.bfce3697.svg";